/**
 * Platform-specific config
 * Web: Next.js environment variables
 */

export const SITE_URL: string =
  process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000';

export const API_URL: string =
  process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5001';
